import { AxiosRequestConfig } from 'axios';
import { AxiosInstance } from 'utils/axiosClient';
import RpcMethod from './rpcMethod';
import { getRpcParams } from './rpcUtils';

export interface IDeviceParams {
  deviceId: number;
  equipmentId: string;
  coupledDate?: string;
  uncoupledDate?: string;
}

export default function deviceRpcService(client: AxiosInstance) {
  return {
    couple: (params: IDeviceParams, config?: AxiosRequestConfig) =>
      client.post('/rpc/device', getRpcParams(RpcMethod.COUPLE_DEVICE, params), config),
    uncouple: (params: IDeviceParams, config?: AxiosRequestConfig) =>
      client.post('/rpc/device', getRpcParams(RpcMethod.UNCOUPLE_DEVICE, params), config),
  };
}
